import React, { useEffect, useState } from 'react';
import { Wrap, Tab, TabButton, List, ListItem } from './styled';
import { ScoreDetailService } from 'services';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

const BasketballBroadCast = observer(({ gameData }) => {
  const { detail } = gameData;
  const { period, teams } = detail;

  const { id } = useParams();
  const [totalItem, setTotalItem] = useState({});
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    ScoreDetailService.getBroadcastsBySportsType('basketball', id).then(
      (res) => {
        setTotalItem(res);
        let items = [];
        for (let item of Object.values(res).reverse()) {
          items = items.concat(item);
        }
        setItems(items);
      }
    );
  }, []);

  useEffect(() => {
    if (active === 0) {
      let items = [];
      for (let item of Object.values(totalItem).reverse()) {
        items = items.concat(item);
      }
      setItems(items);
    } else {
      setItems(totalItem[active] || []);
    }
  }, [active]);

  return (
    <Wrap>
      <Tab>
        <div>
          <TabButton
            active={active === 0}
            onClick={() => setActive(0)}
            disabled={false}
          >
            전체
          </TabButton>
          <TabButton
            active={active === 1}
            onClick={() => setActive(1)}
            disabled={period < 1}
          >
            1쿼터
          </TabButton>
          <TabButton
            active={active === 2}
            onClick={() => setActive(2)}
            disabled={period < 2}
          >
            2쿼터
          </TabButton>
          <TabButton
            active={active === 3}
            onClick={() => setActive(3)}
            disabled={period < 3}
          >
            3쿼터
          </TabButton>
          <TabButton
            active={active === 4}
            onClick={() => setActive(4)}
            disabled={period < 4}
          >
            4쿼터
          </TabButton>
          <TabButton
            active={active === 5}
            onClick={() => setActive(5)}
            disabled={period < 5}
          >
            연장
          </TabButton>
        </div>
      </Tab>
      <List>
        {items.map((item, key) => {
          return <Item key={key} item={item} teams={teams} />;
        })}
      </List>
    </Wrap>
  );
});

const teamNameState = {
  HOME: '',
  AWAY: ''
};

const Item = ({ item, teams }) => {
  const [teamNames, setTeamNames] = useState(teamNameState);

  useEffect(() => {
    let teamData = toJS(teams);
    if (teamData !== undefined) {
      setTeamNames({ HOME: teamData.home.name, AWAY: teamData.away.name });
    }
  }, [teams]);

  const { displayTime, playText, eventType, locationType } = item;
  const teamName = (locationType && `${teamNames[locationType]} `) || '';

  return (
    <ListItem effect={eventType === 'PERIOD_INFO'}>
      <span>{displayTime}</span>
      <p>
        {teamName}
        {playText}
      </p>
    </ListItem>
  );
};

export default BasketballBroadCast;
